import { render, staticRenderFns } from "./organizationSetting.vue?vue&type=template&id=2402a5f0&scoped=true"
import script from "./organizationSetting.vue?vue&type=script&lang=js"
export * from "./organizationSetting.vue?vue&type=script&lang=js"
import style0 from "./organizationSetting.vue?vue&type=style&index=0&id=2402a5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402a5f0",
  null
  
)

export default component.exports